"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _utils = require("@ckeditor/ckeditor5-widget/src/utils");

var _widget = _interopRequireDefault(require("@ckeditor/ckeditor5-widget/src/widget"));

var _clickobserver = _interopRequireDefault(require("@ckeditor/ckeditor5-engine/src/view/observer/clickobserver"));

var _placeholdercommand = _interopRequireDefault(require("./placeholdercommand"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var PlaceholderEditing = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(PlaceholderEditing, _Plugin);

  var _super = _createSuper(PlaceholderEditing);

  function PlaceholderEditing() {
    (0, _classCallCheck2["default"])(this, PlaceholderEditing);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(PlaceholderEditing, [{
    key: "init",
    value: function init() {
      var _this = this;

      this._defineSchema();

      this._defineConverters();

      this.editor.commands.add('placeholder', new _placeholdercommand["default"](this.editor));
      this.editor.editing.mapper.on('viewToModelPosition', (0, _utils.viewToModelPositionOutsideModelElement)(this.editor.model, function (viewElement) {
        return viewElement.hasClass('placeholder');
      }));
      this.editor.config.define('variablesPlaceholderPluginConfig', {
        types: [{
          key: 'first_name',
          title: 'First name'
        }]
      });
      var view = this.editor.editing.view;
      var viewDocument = view.document;
      view.addObserver(_clickobserver["default"]); // When click remove (x) button on the placeholder, we remove the placeholder.

      this.editor.listenTo(viewDocument, 'click', function (_e, data) {
        if (data.target.name === 'button') {
          var modelElement = _this.editor.editing.mapper.toModelElement(data.target.parent);

          if (modelElement.name === 'placeholder') {
            _this.editor.model.change(function (writer) {
              writer.remove(modelElement);
            });
          }
        }
      });
    }
  }, {
    key: "_defineSchema",
    value: function _defineSchema() {
      var schema = this.editor.model.schema;
      schema.register('placeholder', {
        // Allow wherever text is allowed:
        allowWhere: '$text',
        // The placeholder will act as an inline node:
        isInline: true,
        // The inline widget is self-contained so it cannot be split by the caret and it can be selected:
        isObject: true,
        // The inline widget can have the same attributes as text (for example linkHref, bold).
        allowAttributesOf: '$text',
        // The placeholder can have many types, like date, name, surname, etc:
        allowAttributes: ['name']
      });
    }
  }, {
    key: "_defineConverters",
    value: function _defineConverters() {
      var conversion = this.editor.conversion; // Conversion for loading the data to the editor.

      conversion["for"]('upcast').elementToElement({
        view: {
          name: 'span',
          classes: ['placeholder']
        },
        model: function model(viewElement, _ref) {
          var modelWriter = _ref.writer;
          // Extract the "name"
          var name = viewElement.getChild(0).data;
          return modelWriter.createElement('placeholder', {
            name: name
          });
        }
      }); // Conversion for rendering the editor content to the user for editing

      conversion["for"]('editingDowncast').elementToElement({
        model: 'placeholder',
        view: function view(modelItem, _ref2) {
          var viewWriter = _ref2.writer;
          var widgetElement = createPlaceholderView(modelItem, viewWriter); // Enable widget handling on a placeholder element inside the editing view.

          return (0, _utils.toWidget)(widgetElement, viewWriter);
        }
      }); // Conversion for retrieving the data from the editor.

      conversion["for"]('dataDowncast').elementToElement({
        model: 'placeholder',
        view: function view(modelItem, _ref3) {
          var viewWriter = _ref3.writer;
          return createPlaceholderView(modelItem, viewWriter);
        }
      }); // Helper method for both downcast converters.

      function createPlaceholderView(modelItem, viewWriter) {
        var name = modelItem.getAttribute('name');
        var placeholderView = viewWriter.createContainerElement('span', {
          "class": 'placeholder'
        }, {
          isAllowedInsideAttributeElement: true
        }); // If it is not for retrieving data
        // add x button for removing the placeholder

        var removeBtnView = viewWriter.createContainerElement('button');
        viewWriter.insert(viewWriter.createPositionAt(placeholderView, 0), removeBtnView);
        viewWriter.insert(viewWriter.createPositionAt(removeBtnView, 0), viewWriter.createText('x'));
        var innerText = viewWriter.createText(name);
        viewWriter.insert(viewWriter.createPositionAt(placeholderView, 0), innerText);
        return placeholderView;
      }
    }
  }], [{
    key: "requires",
    get: function get() {
      return [_widget["default"]];
    }
  }]);
  return PlaceholderEditing;
}(_plugin["default"]);

exports["default"] = PlaceholderEditing;
//# sourceMappingURL=placeholderediting.js.map